import React from "react";
import GloLogoBlack from "./img/glo-logo-black.svg?react";
import VuseLogo from "./img/vuse-logo.svg?react";
import VeloLogo from "./img/velo-logo.svg?react";
import Tomorrowland from "./img/tomorrowland.svg?react";
import "./style.scss";

export default function BrandLogo({
  brands = false,
  desktopBig = false,
  className = "",
}) {
  if (!brands || brands?.length === 0) {
    return;
  }

  const childrenCount = brands.length;

  return (
    <div
      className={`brand-logo-component ${desktopBig ? "desktop-bigger" : ""} ${
        childrenCount === 2
          ? "two-childs"
          : childrenCount === 3
          ? "three-childs"
          : ""
      } ${className}`}
    >
      {brands.map((brand, index) => (
        <div className="brand" key={index}>
          {brand === "glo" && <GloLogoBlack />}
          {brand === "vuse" && <VuseLogo />}
          {brand === "velo" && <VeloLogo />}
          {brand === "tomorrowland" && <Tomorrowland />}
        </div>
      ))}
    </div>
  );
}
